import { NavLink, useNavigate } from "react-router-dom";
import {
	LayoutDashboard,
	MessageSquare,
	FileText,
	LogOut,
	Key,
} from "lucide-react";
//import Logo from "../assets_download_placeholder.png";
import { useState } from "react";
import ChangePassword from "./ChangePassword"; // Import the component
import Logo from "../assets/parallex-logo.png"; 
const Sidebar = () => {
	const navigate = useNavigate();
	const [changePasswordOpen, setChangePasswordOpen] = useState(false);

	const handleLogout = () => {
		localStorage.clear();
		navigate("/login");
	};

	const navItemClass =
		"flex items-center gap-3 text-white hover:text-accent py-2 px-4 rounded transition-all";

	return (
		<>
			<div className='bg-primary text-white h-screen w-64 p-6 fixed top-0 left-0 flex flex-col justify-between'>
				{/* Top */}
				<div>
					<div className="flex items-center justify-center mb-10 px-1">
						<img
							src={Logo}
							alt="Parallex Bank"
							className="w-full max-w-[190px] h-auto object-contain"
						/>
						</div>

					<nav className='flex flex-col gap-2'>
						<NavLink to='/dashboard' className={navItemClass}>
							<LayoutDashboard size={18} /> Dashboard
						</NavLink>
						<NavLink to='/messages' className={navItemClass}>
							<MessageSquare size={18} /> Messages
						</NavLink>
						<NavLink to='/logs' className={navItemClass}>
							<FileText size={18} /> Logs
						</NavLink>
					</nav>
				</div>

				{/* Bottom (Settings & Logout) */}
				<div className='space-y-2'>
					<button
						onClick={() => setChangePasswordOpen(true)}
						className={navItemClass}
					>
						<Key size={18} /> Change Password
					</button>
					<button onClick={handleLogout} className={navItemClass}>
						<LogOut size={18} /> Logout
					</button>
				</div>
			</div>

			{/* Change Password Dialog */}
			<ChangePassword
				open={changePasswordOpen}
				onClose={() => setChangePasswordOpen(false)}
			/>
		</>
	);
};

export default Sidebar;
